//initial redux
import {
    put,
    call,
    takeEvery,
    takeLatest,
    fork,
    all,
    take,
    select
} from "redux-saga/effects";
import {
    delay
} from "redux-saga";
import * as router from "react-router-redux";
import {
    types as logintypes
} from "../../../ui/Login/redux";
import {
    types as sitetreetypes
} from "../../../services/SiteTree/redux";
import {
    string,
    TreeFlatener,
    TreeMap
} from "../../../utils";
import pointsservice from "../../../services/points";
import moment from "moment-timezone";
import takeLeading from "../../../utils/takeLeading";

const MENU_METER_CONFIG = "menuLiveDataConfig";
const LIVE_DATA_INTERVAL = 5000;

const initialState = {
    errors: [],

    dailyUsagePointId: null,
    currentUsagePointId: null,
    currentTempPointId: null,
};

/////////
//types
export const types = {
    START_COMPONENT: "screens/menu/START_COMPONENT",
    STOP_COMPONENT: "screens/menu/STOP_COMPONENT",
    SET_DAILY_USAGE_POINT_ID: "screens/menu/SET_DAILY_USAGE_POINT_ID",
    SET_CURRENT_USAGE_POINT_ID: "screens/menu/SET_CURRENT_USAGE_POINT_ID",
    SET_CURRENT_TEMP_POINT_ID: "screens/menu/SET_CURRENT_TEMP_POINT_ID",
    SET_DAILY_USAGE: "screens/menu/SET_DAILY_USAGE",
    SET_CURRENT_USAGE: "screens/menu/SET_CURRENT_USAGE",
    SET_CURRENT_TEMP: "screens/menu/SET_CURRENT_TEMP",

    UPDATE_LIVE_DATA: "screens/menu/UPDATE_LIVE_DATA",
    LOAD_POINT_IDS: "screens/menu/LOAD_POINT_IDS",
};

///////////
//reducers
export const reducers = {
    reducer(state = initialState, action) {
        switch (action.type) {
            case types.UPDATE_LIVE_DATA:{
                return state;
            }
            case types.LOAD_POINT_IDS:{
                return state;
            }
            case types.SET_DAILY_USAGE_POINT_ID:{
                return {...state, dailyUsagePointId: action.payload};
            }
            case types.SET_CURRENT_USAGE_POINT_ID:{
                return {...state, currentUsagePointId: action.payload};
            }
            case types.SET_CURRENT_TEMP_POINT_ID:{
                return { ...state, currentTempPointId: action.payload};
            }
            case types.SET_DAILY_USAGE:{
                return { ...state, dailyUsage: action.payload }
            }
            case types.SET_CURRENT_USAGE:{
                return { ...state, currentUsage: action.payload }
            }
            case types.SET_CURRENT_TEMP: {
                return { ...state, currentTemp: action.payload }
            }
            default:
                return state;
        }
    }
};

function* loadDailyUsage() {
    const dailyUsagePointId = yield select(x => x.rtMenuDataRedux.dailyUsagePointId);
    const currentSite = yield select(x => x.sitetree.currentSite);
    if (!dailyUsagePointId || !currentSite) {
        yield put(actions.setDailyUsage(0));
    } else {
        let utcOffset = 0;
        if (currentSite.momentTimezone) {
            utcOffset = moment().tz(currentSite.momentTimezone).utcOffset();
        }
        let fromDate = moment().utc().add(utcOffset, 'm').startOf('day');
        let toDate = moment().utc().add(utcOffset, 'm').endOf('day');
        const dailyUsage = yield call(pointsservice.TrendableDataGetData, dailyUsagePointId, fromDate, toDate, null, null, "Daily", true, true);
        if (dailyUsage instanceof Error || !dailyUsage) {
            return;
        }
        let usage = 0;
        if (dailyUsage && dailyUsage.length) {
            usage = dailyUsage[0].value;
        }
        yield put(actions.setDailyUsage(usage));
    }
}

function* loadCurrentUsage() {
    const currentUsagePointId = yield select(x => x.rtMenuDataRedux.currentUsagePointId);
    if (!currentUsagePointId) {
        yield put(actions.setCurrentUsage(0));
    } else {
        const currentUsage = yield call(pointsservice.LiveDataGet, currentUsagePointId);
        if (currentUsage instanceof Error || !currentUsage) {
            return;
        }
        let usage = 0;
        if (currentUsage && currentUsage[currentUsagePointId]) {
            usage = currentUsage[currentUsagePointId].value;
            usage = usage ? usage : 0;
        }
        yield put(actions.setCurrentUsage(usage));
    }
}

function* loadCurrentTemp() {
    const currentTempPointId = yield select(x => x.rtMenuDataRedux.currentTempPointId);
    if (!currentTempPointId) {
        yield put(actions.setCurrentTemp(0));
    } else {
        const currentTemp = yield call(pointsservice.LiveDataGet, currentTempPointId);
        if (currentTemp instanceof Error || !currentTemp) {
            return;
        }
        let temp = 0;
        if (currentTemp && currentTemp[currentTempPointId]) {
            temp = currentTemp[currentTempPointId].value;
            temp = temp ? temp : 0;
        }
        yield put(actions.setCurrentTemp(temp));
    }
}

function getChildViewByName(flattenedSiteTree, view, name) {
    let childView = null;
    if (flattenedSiteTree && name && view && view._tree && view._tree.children && view._tree.children.length) {
        for (var ii = 0; ii < view._tree.children.length; ii++) {
            let wkView = flattenedSiteTree[view._tree.children[ii]];
            if (wkView && wkView.name === name) {
                childView = wkView;
                break;
            }
        }
    }
    return childView;
}

function getView(flattenedSiteTree, rootView, paths){
	let result = null;

	let wkView = rootView;
	if(flattenedSiteTree && rootView && paths && paths.length && flattenedSiteTree.Roots.length){
		for(var ii = 0; ii < paths.length; ii++){
			let wkPath = paths[ii];
         let nextView = null;
         
         const childs = flattenedSiteTree.GetChildrenFor(wkView);

         for (let index = 0; index < childs.length; index++) {
            const childView = childs[index];
            if(childView.name === wkPath){
               nextView = childView;
               break;
            }
         }

			if(!nextView){
				break;
			}else{
				wkView = nextView;
			}
			if(ii === paths.length - 1){
				result = wkView;
			}
		}
	}

	return result;
}

//////////
//sagas
export const sagas = {
    * rootSaga() {
        yield all([
            this.startComponent(),
            liveDataSaga.start(),
            this.loadPointIds(),
        ]);
    },
    * startComponent() {
        yield takeLatest(types.START_COMPONENT, function* () {
            for (;;) {
                var showing = yield select(x => x.header.showSelect);
                if(showing) {
                    yield put(actions.updateLiveData());
                }
                yield delay(LIVE_DATA_INTERVAL);
            }
        });
    },
    * loadPointIds() {
        yield takeLatest([sitetreetypes.SET_CURRENT_SITE, sitetreetypes.ON_LOAD, types.START_COMPONENT], function* () {
            const [flattenedSiteTree, currentSite] = yield all([
                select(s => s.sitetree.flattenedSiteTree),
                select(s => s.sitetree.currentSite),
            ]);
            if (!flattenedSiteTree || !currentSite || !currentSite._tree || !currentSite._tree.children || !currentSite._tree.children.length) {
                yield put(actions.setDailyUsage(0));
                yield put(actions.setCurrentUsage(0));
                yield put(actions.setCurrentTemp(0));
                return;
            }
            const dailyUsagePoint = getView(flattenedSiteTree, currentSite, ["Meters", "Main"]);
            const currentUsagePoint = getView(flattenedSiteTree, currentSite, ["Meters.kW", "Main"]);
            const currentTempPoint = getView(flattenedSiteTree, currentSite, ["Ambient", "DegC"]);

            let dailyUsagePointId = dailyUsagePoint ? dailyUsagePoint.objectID : null;
            let currentUsagePointId = currentUsagePoint ? currentUsagePoint.objectID : null;
            let currentTempPointId = currentTempPoint ? currentTempPoint.objectID : null;

            yield all([
                put(actions.setDailyUsagePointId(dailyUsagePointId)),
                put(actions.setCurrentUsagePointId(currentUsagePointId)),
                put(actions.setCurrentTempPointId(currentTempPointId)),
            ]);
            yield put(actions.updateLiveData());
        });
    },
};

const liveDataSaga = {
    *start() {
        yield all([
            this.updateDailyUsage(),
            this.updateCurrentUsage(),
            this.updateCurrentTemp()
        ])
    },
    *updateDailyUsage() {
        yield takeLeading(types.UPDATE_LIVE_DATA, loadDailyUsage);
    },
    *updateCurrentUsage() {
        yield takeLeading(types.UPDATE_LIVE_DATA, loadCurrentUsage);
    },
    *updateCurrentTemp() {
        yield takeLeading(types.UPDATE_LIVE_DATA, loadCurrentTemp);
    }
}

////////
//actions
export const actions = {
    setDailyUsagePointId(payload) {
        return {
            type: types.SET_DAILY_USAGE_POINT_ID,
            payload
        }
    },
    setCurrentUsagePointId(payload) {
        return {
            type: types.SET_CURRENT_USAGE_POINT_ID,
            payload
        }
    },
    setCurrentTempPointId(payload) {
        return {
            type: types.SET_CURRENT_TEMP_POINT_ID,
            payload
        }
    },

    setDailyUsage(payload) {
        return {
            type: types.SET_DAILY_USAGE,
            payload
        }
    },
    setCurrentUsage(payload) {
        return {
            type: types.SET_CURRENT_USAGE,
            payload
        }
    },
    setCurrentTemp(payload) {
        return {
            type: types.SET_CURRENT_TEMP,
            payload
        }
    },
    updateLiveData(payload) {
        return {
            type: types.UPDATE_LIVE_DATA,
            payload
        }
    },


    setLiveMeters(conf) {
        return {
            type: types.SET_LIVE_METERS,
            payload: {
                conf
            }
        };
    },

    onGetLiveData(data) {
        return {
            type: types.ON_GET_LIVE_DATA,
            payload: {
                data
            }
        };
    },
    startComponent() {
        return {
            type: types.START_COMPONENT,
            payload: {}
        };
    },
    stopComponent() {
        return {
            type: types.STOP_COMPONENT,
            payload: {}
        };
    },

    genericAction(type, data) {
        return {
            type,
            payload: data
        };
    }
};


// WEBPACK FOOTER //
// ./src/components/Realtime/MenuData/redux.js